import React from "react";
import ImContainer from "./../containers/ImContainer";

function FormIM() {
  return <ImContainer></ImContainer>;
}

export default FormIM;
